module.exports = __webpack_public_path__ + "assets/img/1.30bfb529.png";